/**
 * @description
 * This url represents the axios baseURL
 */
export const URL = process.env.VUE_APP_NODE_ENV === 'development'
    ? process.env.VUE_APP_DEVELOPMENT_API_URL
    : process.env.VUE_APP_PRODUCTION_API_URL;

/**
 * @description
 * global namespace enum-like to handle user roles
 */
export const Role = {
    admin: 1,
    client: 2,
    merchant: 3,
    all: 5
};
